import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const TimeSeriesBookingsChart = ({ rows }) => {
  const [chartData, setChartData] = useState({
    options: { xaxis: { categories: [] } },
    series: [{ name: "Total Bookings", data: [] }],
  });

  useEffect(() => {
    if (!rows || rows.length === 0) {
      setChartData({
        options: { xaxis: { categories: [] } },
        series: [{ name: "Total Bookings", data: [] }],
      });
      return;
    }

    const categories = rows.map((r) => r.label);
    const totals = rows.map((r) => r.total);

    setChartData({
      options: {
        chart: { id: "time-series-bookings" },
        colors: ["#FBB034"],
        xaxis: {
          categories,
          labels: {
            style: {
              colors: "#FFFFFF", // 👈 X-axis labels white
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#FFFFFF", // 👈 Y-axis labels white
            },
          },
        },
        tooltip: {
          custom: function ({ dataPointIndex }) {
            const day = rows[dataPointIndex];
            if (!day) return "";

            let tooltipHtml = `<div style="padding:8px;">
              <strong>${day.label}</strong><br/>
              <span>Total: ${day.total}</span><br/>`;

            if (day.statuses) {
              Object.entries(day.statuses).forEach(([status, count]) => {
                tooltipHtml += `<span>${status}: ${count}</span><br/>`;
              });
            }

            tooltipHtml += `</div>`;
            return tooltipHtml;
          },
        },
      },
      series: [{ name: "Total Bookings", data: totals }],
    });
  }, [rows]);

  return (
    <Chart
      options={chartData.options}
      series={chartData.series}
      type="bar"
      width="100%"
      height={400}
    />
  );
};

export default TimeSeriesBookingsChart;
